/**
 * Created by stonewang on 2017/8/18.
 */
import React from 'react';
import { Input, Checkbox, InputNumber } from 'antd';

class EditableCell extends React.Component {
  state = {
    type: this.props.type || '',
    value: this.props.value,
    editable: this.props.editable || false,
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.editable !== this.state.editable) {
      this.setState({ editable: nextProps.editable });
      if (nextProps.editable) {
        this.cacheValue = this.state.value;
      }
    }
    if (nextProps.status && nextProps.status !== this.props.status) {
      if (nextProps.status === 'save') {
        this.props.onChange(this.state.value);
      } else if (nextProps.status === 'cancel') {
        this.setState({ value: this.cacheValue });
        this.props.onChange(this.cacheValue);
      }
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.editable !== this.state.editable ||
      nextState.value !== this.state.value;
  }
  handleChange(e) {
    let value = '';
    if(e.target){
      value = e.target.value || e.target.checked;
    }else{
      value = e;
    }
    this.setState({ value });
  }
  render() {
    const { value, editable, type } = this.state;
    return (
      <div>
        {
          editable ?
            <div>
              {
                type && type==='checkbox' ? <Checkbox checked={value} onChange={e => this.handleChange(e)} /> :
                  ( type && type==='number'?
                    <InputNumber min={0}  value={value} onChange={e => this.handleChange(e)} style={{width: '100%'}} /> :
                    <Input value={value} onChange={e => this.handleChange(e)} style={{width: '100%'}}/>
                  )
              }
            </div>
            :
            <div className="editable-row-text">
              {
                type && type==='checkbox' ?
                  (value ? '是' : '否') :
                  (value.toString() || ' ')
              }
            </div>
        }
      </div>
    );
  }
}
export default EditableCell;


// WEBPACK FOOTER //
// ./src/components/editableCell.js